export default __webpack_public_path__ + "static/media/digitalcard_ticket.3c1ddaca.svg";